import { render } from "./AddCertificate.vue?vue&type=template&id=7b543b0e&scoped=true"
import script from "./AddCertificate.vue?vue&type=script&lang=js"
export * from "./AddCertificate.vue?vue&type=script&lang=js"

import "./AddCertificate.vue?vue&type=style&index=0&id=7b543b0e&lang=scss&scoped=true"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b543b0e"]])

export default __exports__